import React from 'react';
import ReactMarkdown from 'react-markdown';

import Card from 'react-bootstrap/Card'

type CardBodyMarkdownProps = {
  /** The Markdown-formatted string to render. */
  children: string | null | undefined;
};

// noinspection GrazieInspection
/**
 * Renders markdown content inside a Bootstrap Card.Body using react-markdown.
 */
const CardBodyMarkdown = ({children}: CardBodyMarkdownProps) => {
  return (
    <Card.Body>
      <ReactMarkdown>{children}</ReactMarkdown>
    </Card.Body>
  );
}

export default CardBodyMarkdown;